import { gettext } from '@eventbrite/i18n';
import isArray from 'lodash/isArray';
import last from 'lodash/last';
import { DiscoverState } from '../../types/index';
import {
    formatDateRangeStringForDisplay,
    getSearchEventHeaderTitle,
} from '../../utils/general';

//If no date filter is applied the value will
//default to "current_future", if any filters
//are applied we will receive an array with
//both 'current_future' and whatever other
//filters. But that is only instance of more
//than one filter so we can feel safe returning
//the second option.
export const getSelectedDate = (
    date?: string[],
    { from: startDate, to: endDate }: { from?: string; to?: string } = {},
) => {
    let dateToReturn;

    if (isArray(date)) {
        dateToReturn = last(date) === 'current_future' ? undefined : last(date);
    }

    if (startDate && endDate) {
        dateToReturn = formatDateRangeStringForDisplay({ startDate, endDate });
    }

    return dateToReturn;
};

export const getSearchHeaderTitle = (
    state: Pick<DiscoverState, 'botH1' | 'location' | 'search'>,
) => {
    if (state.botH1) {
        return state.botH1;
    }

    return getSearchEventHeaderTitle(
        {
            currentPlace: state.location?.currentPlace || '',
            currentPlaceParent: state.location?.currentPlaceParent || '',
            placeType: state.location?.placeType,
            isOnline: state.location?.isOnline,
        },
        {
            eventSearch: state.search.eventSearch,
        },
    );
};

export const getSearchHeaderSubtitle = (
    state: Pick<DiscoverState, 'location' | 'search'>,
): string => {
    const dates = state.search.eventSearch?.dates;
    const currentPlace = state.location?.currentPlace || 'your area';

    const hasToday = dates?.includes('today');
    const hasThisWeekend = dates?.includes('this_weekend');

    if (hasToday) {
        return gettext(
            'Looking for things to do in %(location)s today? Explore popular events, concerts, workshops, networking meetups, food experiences, and free activities happening across %(location)s right now.',
            { location: currentPlace },
        ).toString();
    }

    if (hasThisWeekend) {
        return gettext(
            "Looking for things to do in %(location)s this weekend? Explore our real-time listings for the best concerts, nightlife, and food and drink experiences. From seasonal festivals and comedy shows to free activities, find your next plan with our constantly updated feed of %(location)s's most popular events.",
            { location: currentPlace },
        ).toString();
    }

    return gettext(
        'Search for something you love or check out popular events in your area.',
    ).toString();
};
